module.exports = __webpack_public_path__ + "img/2.4_Students-Trainees_2_Dale.0212a0b73c627c21a141dc4bd3296d82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.4_Students-Trainees_2_Dale.png
// module id = 324
// module chunks = 0